// Do NOT add "use client" to this file
import { PLACEHOLDER_IMAGE } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/consts";
export var getValidImageOrPlaceholder = function(validImage) {
    return (validImage === null || validImage === void 0 ? void 0 : validImage.url) ? validImage : PLACEHOLDER_IMAGE;
};
